import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

const EditRoomCondition = () => {
  return (
    <Edit
      title="Редактиране на състояние на стая"
      mutationMode="pessimistic"
      transform={({ descriptionBg, descriptionEn }) => ({ descriptionBg, descriptionEn })}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditRoomCondition;
